var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.addAccountFlag
    ? _c(
        "el-dialog",
        {
          staticClass: "add_account_page",
          attrs: {
            width: "631px",
            modal: false,
            "show-close": false,
            visible: _vm.addAccountFlag,
            "before-close": _vm.handleClose,
            "modal-append-to-body": true,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addAccountFlag = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "download-title",
              attrs: { slot: "title" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.noClick.apply(null, arguments)
                },
              },
              slot: "title",
            },
            [
              _c("p", [
                _vm._v("【" + _vm._s(_vm.title) + "自媒体客户端Plus】下载提示"),
              ]),
              _c("i", {
                staticClass: "el-icon-close",
                on: { click: _vm.handleClose },
              }),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "download-content",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.noClick.apply(null, arguments)
                },
              },
            },
            [
              _c("p", { staticClass: "gray-cls" }, [
                _vm._v(" 由于发布需要，当前操作需要"),
                _c("span", { staticClass: "color1" }, [_vm._v("安装并运行")]),
                _c("span", { staticClass: "color3" }, [
                  _vm._v(_vm._s(_vm.title) + "自媒体客户端Plus版本"),
                ]),
                _vm._v("。 "),
              ]),
              _c("p", { staticClass: "gray-cls" }, [
                _vm._v("点击【下载】，快速完成下载和安装。"),
              ]),
              _c("p", [
                _vm._v(
                  "如果已安装，请手动启动" +
                    _vm._s(_vm.title) +
                    "自媒体客户端Plus版本"
                ),
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "download-cont-img flex flex-column download-cont-img1",
                },
                [
                  _c("p", [_vm._v(_vm._s(_vm.title) + "自媒体客户端Plus")]),
                  _c("div", { staticClass: "flex flex-center" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/image/account/icon_mac_download_new.png"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.downloadDoc(2)
                        },
                      },
                    }),
                    _c("img", {
                      attrs: {
                        src: require("../../assets/image/account/icon_windows_download_new.png"),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.downloadAndriod(2)
                        },
                      },
                    }),
                  ]),
                ]
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }